const DEFAULT_PRODUCTION_API_URL = 'https://manage.swarvinnfoods.co.uk/api';

function isLocalApiUrl(value) {
  return /127\.0\.0\.1|localhost/i.test(String(value || ''));
}

export function getApiBase() {
  if (process.env.NODE_ENV === 'development') {
    // Always use the CRA/setupProxy same-origin path in development.
    return '/api';
  }

  const configured = process.env.REACT_APP_API_URL || DEFAULT_PRODUCTION_API_URL;

  // Guard against accidentally baking local .env into a production build.
  if (isLocalApiUrl(configured)) {
    return DEFAULT_PRODUCTION_API_URL;
  }

  return String(configured).replace(/\/$/, '');
}

export function getApiOrigin() {
  const base = getApiBase();

  if (base.startsWith('http://') || base.startsWith('https://')) {
    try {
      const url = new URL(base);
      url.pathname = url.pathname.replace(/\/api\/?$/, '');
      return url.origin + url.pathname.replace(/\/$/, '');
    } catch {
      return DEFAULT_PRODUCTION_API_URL.replace(/\/api$/, '');
    }
  }

  return typeof window !== 'undefined' ? window.location.origin : 'https://swarvinnfoods.co.uk';
}

export const API_BASE = getApiBase();
